module.exports = __webpack_public_path__ + "img/palabrassilabastrabadas.2b6818dd.png";